// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"LoginPage_loginPage__-xLBP","loginHeader":"LoginPage_loginHeader__ZBPWr","loginWrapper":"LoginPage_loginWrapper__3mlQt"};